import { InsulationMaterial } from "../types/types"
import { genericRequest, insulationMaterialRoute } from "./service"

/**
 * Gets all insulation materials.
 * 
 * @returns A list of insulation materials or an error.
 */
export const getInsulationMaterials = async (): Promise<InsulationMaterial[] | Error> => {
  return await genericRequest({ url: `${insulationMaterialRoute}/`, method: "GET" })
}